/*
  Input class object initialised with array
  Output Method that we call on object to get randomised values
 */

export interface RandomisedListsInterface<T> {
    breakfast: Array<T>,
    lunch: Array<T>,
    supper: Array<T>
}

export class Randomise<T> {
    private _breakfastList: Array<T>
    private _lunchList: Array<T>
    private _supperList: Array<T>

    private _breakfastSeed: number = 0;
    private _lunchSeed: number = 0;
    private _supperSeed: number = 0;

    private _ListLength: number = 0;

    constructor(breakfastList: Array<T>, lunchList: Array<T>, supperList: Array<T>) {
        this.ensureListsAreOfEqualLength(breakfastList, lunchList, supperList);

        this._breakfastList = breakfastList
        this._lunchList = lunchList
        this._supperList = supperList

        this._ListLength = this._breakfastList.length;
    }

    private ensureListsAreOfEqualLength(list1: Array<T>, list2: Array<T>, list3: Array<T>): void {
        const leadLength: number = list1.length,
            list2HasEqualLength: boolean = list2.length === leadLength,
            list3HasEqualLength: boolean = list3.length === leadLength;

        if (!list2HasEqualLength || !list3HasEqualLength)
            throw new Error('Lists are not of similar lengths');
    }

    private getSeededRandomNumberWithMaxListLength(seed: number): number {
        let randomNumber: number = Math.floor(Math.random() * this._ListLength)

        while (randomNumber == 0 || seed == randomNumber)
            randomNumber = Math.ceil(Math.random() * this._ListLength)

        return randomNumber
    }

    private getAndSeedBreakfastRandomNumber(): number {
        let breakfastRandomNumber: number = this.getSeededRandomNumberWithMaxListLength(this._breakfastSeed);

        this._breakfastSeed = breakfastRandomNumber;
        return breakfastRandomNumber
    }

    private getAndSeedLunchRandomNumber(): number {
        let lunchRandomNumber: number = this.getSeededRandomNumberWithMaxListLength(this._lunchSeed);

        this._lunchSeed = lunchRandomNumber;
        return lunchRandomNumber
    }

    private getAndSeedSupperRandomNumber(): number {
        let supperRandomNumber: number = this.getSeededRandomNumberWithMaxListLength(this._supperSeed);

        this._supperSeed = supperRandomNumber;
        return supperRandomNumber
    }

    private generateIndiceListFromMealListsLength(): Array<number> {
        let initIndiceList: Array<number> = [];

        for (let i = 0; i < this._ListLength; i++)
            initIndiceList.push(i);

        return initIndiceList;
    }

    private checkAndReturnValidIndice(num: number): number {
        const indice = num > (this._ListLength - 1) ?
            (num - this._ListLength) :
            num

        return indice;
    }

    private generateRandomisedMealList(randomNumber: number, mealList: Array<T>): Array<T> {
        const initIndiceList: Array<number> = this.generateIndiceListFromMealListsLength();
        const randomisedMealList: Array<T> = [];

        for (let indice of initIndiceList) {
            indice += randomNumber
            indice = this.checkAndReturnValidIndice(indice)

            randomisedMealList.push(mealList[indice]);
        }

        return randomisedMealList;
    }

    public getRandomisedMealLists(): RandomisedListsInterface<T> {
        const breakFastRandomNumber: number = this.getAndSeedBreakfastRandomNumber(),
            lunchRandomNumber: number = this.getAndSeedLunchRandomNumber(),
            supperRandomNumber: number = this.getAndSeedSupperRandomNumber();

        const randomisedBreakfastList = this.generateRandomisedMealList(breakFastRandomNumber, this._breakfastList),
            randomisedLunchList = this.generateRandomisedMealList(lunchRandomNumber, this._lunchList),
            randomisedSupperList = this.generateRandomisedMealList(supperRandomNumber, this._supperList);

        const listObject: RandomisedListsInterface<T> = {
            breakfast: randomisedBreakfastList,
            lunch: randomisedLunchList,
            supper: randomisedSupperList
        }
        return listObject
    }

}
